import { render, staticRenderFns } from "./assetInPortafoglioTable.vue?vue&type=template&id=d1340a16&"
import script from "./assetInPortafoglioTable.vue?vue&type=script&lang=ts&"
export * from "./assetInPortafoglioTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports